export const cubicNikitosa = 'cubic-bezier(.25,.1,.25,1)';
export const trans = `.3s ${cubicNikitosa}`;
